import {applySpec, firstOf, flow, get, ifElse, makeGet} from '@logistics-frontend/utils'
import {type SuggestObject} from '@yandex-delivery/api/model/suggest'

import type {AddressSuggestState} from '../types'

const suggestObjectGetter = makeGet<SuggestObject>()

// Getters
const getPos = firstOf(suggestObjectGetter('location'), suggestObjectGetter('position'))
const getTitleText = suggestObjectGetter('title.text')
const getSubTitleText = suggestObjectGetter('subtitle.text')
const getText = suggestObjectGetter('text')
const getCity = suggestObjectGetter('city')
const getCountry = suggestObjectGetter('country')
const getStreet = suggestObjectGetter('street')
const getHouse = suggestObjectGetter('house')
const getPorchNumber = suggestObjectGetter('porchnumber')
const getFloorNumber = suggestObjectGetter('floorNumber')
const getQuartersNumber = suggestObjectGetter('quartersNumber')
const getDoorPhoneNumber = suggestObjectGetter('doorPhoneNumber')
const getUri = suggestObjectGetter('uri')
const getComment = suggestObjectGetter('comment')
const getContact = suggestObjectGetter('contact')
const getIsSavedAddress = suggestObjectGetter('isSavedAddress')
const getAddressID = suggestObjectGetter('address.addressId')

// Checkers
const isSavedAddress = flow(getIsSavedAddress, Boolean)

// Mappers
const toCoordinates: (suggestObject: SuggestObject) => AddressSuggestState['coordinates'] = getPos
const toFullName: (suggestObject: SuggestObject) => AddressSuggestState['fullName'] = ifElse(
  isSavedAddress,
  getSubTitleText,
  getText,
)
const toContact: (suggestObject: SuggestObject) => AddressSuggestState['contact'] = applySpec<
  AddressSuggestState['contact']
>({
  phone: flow(getContact, get('phoneNumber')),
  email: flow(getContact, get('email')),
})

export const toAddressSuggestState: (suggestObject?: SuggestObject) => AddressSuggestState =
  applySpec<AddressSuggestState>({
    id: getAddressID,
    city: getCity,
    street: getStreet,
    shortName: getTitleText,
    comment: getComment,
    country: getCountry,
    doorCode: getDoorPhoneNumber,
    floor: getFloorNumber,
    flat: getQuartersNumber,
    porch: getPorchNumber,
    building: getHouse,
    uri: getUri,
    contact: toContact,
    fullName: toFullName,
    coordinates: toCoordinates,
  })
